export default class ActionPolicy {
    static browse(user) {
        return user.hasPermissionTo('browse:actions');
    }

    static add(user) {
        return user.hasPermissionTo('add:actions');
    }

    static edit(user, action) {
        return action.deleted_at === null
            && user.hasPermissionTo('edit:actions');
    }

    static duplicate(user, action) {
        return this.add(user) && this.edit(user, action);
    }

    static destroy(user, action) {
        return action.deleted_at === null
            && user.hasPermissionTo('delete:actions');
    }

    static restore(user, action) {
        return action.deleted_at !== null
            && user.hasPermissionTo('delete:actions');
    }

    /* eslint-disable-next-line no-unused-vars */
    static sort(user, action) {
        return user.hasPermissionTo('edit:actions');
    }

    static updateSortIndex(user, action, destination) {
        if (!ActionPolicy.sort(user, action)) {
            return false;
        }

        if (!destination) {
            return false;
        }

        return action.sort_index !== Number(destination);
    }
}
